import { Tooltip } from "antd/es";
import _ from "lodash";
import { PureComponent, ReactNode } from "react";
import withCommonEvents from "../../../shared/hoc/with-common-events";
import { CommonProps } from "../common-props";
import { DashboardState } from "../kuika-cl-model-runtimes";

declare let window: any;

type IconType = "filled" | "outlined" | "round" | "sharp" | "two-tone";

const ICON_CLASS_MAP: Record<IconType, string> = {
  filled: "material-icons",
  outlined: "material-icons-outlined",
  round: "material-icons-round",
  sharp: "material-icons-sharp",
  "two-tone": "material-icons-two-tone"
};

interface IconProps {
  iconName: string;
  style: any;
  hoverText?: string;
  rounded?: boolean;
  iconType?: IconType;
}

interface IconState {}

class Icon extends PureComponent<IconProps & CommonProps, IconState> {
  constructor(props: IconProps) {
    super(props);
    this.state = {};
  }

  getProps = () => {
    let result: any = {};
    if (this.props && this.props.style) {
      result = _.clone(this.props);
      if (result && result.style) {
        delete result.style;
      }
      if (result && result.rounded) {
        delete result.rounded;
      }
      if (result && result.iconType) {
        delete result.iconType;
      }
    }
    return result;
  };

  getStyleProp = () => {
    let style: any = {};

    if (this.props.style) {
      style = _.clone(this.props.style);
      if (this.props.style?.fontFamily) {
        delete style.fontFamily;
      }
    }
    if (this.props.showCursorPointer) {
      style.cursor = "pointer";
    }
    if (style.display !== "block") {
      style.display = "inline-block";
    }
    style.verticalAlign = "middle";

    if (window?.kuika?.dashboardState === DashboardState.reportDesigner) {
      style.height = "100%";
      style.display = "flex";
      style.alignItems = "center";
      style.justifyContent = "center";
    }
    return style;
  };

  getIconClassName = () => {
    if (this.props.iconType) {
      return ICON_CLASS_MAP[this.props.iconType] || "material-icons";
    }
    if (this.props.rounded) {
      return "material-icons-round";
    }
    return "material-icons";
  };

  render(): ReactNode {
    const iconClass = `${this.getIconClassName()} md-48`;

    if (this.props.hoverText) {
      return (
        <>
          <Tooltip color={"white"} title={this.props.hoverText}>
            <i style={this.getStyleProp()} {...this.getProps()} className={iconClass}>
              {this.props.iconName}
            </i>
          </Tooltip>
        </>
      );
    }
    return (
      <>
        <i style={this.getStyleProp()} {...this.getProps()} className={iconClass}>
          {this.props.iconName}
        </i>
      </>
    );
  }
}

const icon = withCommonEvents(Icon);
export { icon as Icon };
